// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle-button {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border-radius: 50px;
  border: 1px solid #ccc;
  background: #fff;
  position: relative;
  height: 28px;
}
.toggle-button.checked {
  background: rgb(227.9179104478, 253.5820895522, 238.2686567164);
}
.toggle-button:hover {
  border-color: #0abf53;
}
.toggle-button__input {
  display: none;
}
.toggle-button__input:checked ~ .toggle-button__indicator {
  background-color: #0abf53;
  left: calc(100% - 28px);
  border-color: rgb(227.9179104478, 253.5820895522, 238.2686567164);
}
.toggle-button__input:checked ~ .toggle-button__text--checked {
  display: block;
}
.toggle-button__input:checked ~ .toggle-button__text--unchecked {
  display: none;
}
.toggle-button__indicator {
  width: 24px;
  height: 24px;
  display: inline-block;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-right: 8px;
  background: #ccc;
  position: absolute;
  transition: all 0.3s;
}
.toggle-button__text--checked {
  display: none;
  padding: 0 8px;
  transition: all 0.3s;
}
.toggle-button__text--unchecked {
  display: block;
  padding: 0 8px 0 30px;
  transition: all 0.3s;
}

.checkbox-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ToggleButton/ToggleButton.scss","webpack://./src/utils/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AADF;AAGE;EACE,+DAAA;AADJ;AAIE;EACE,qBCjBY;ADehB;AAIE;EACE,aAAA;AAFJ;AAKM;EACE,yBCxBQ;EDyBR,uBAAA;EACA,iEAAA;AAHR;AAOQ;EACE,cAAA;AALV;AAOQ;EACE,aAAA;AALV;AAUE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AARJ;AAWI;EACE,aAAA;EACA,cAAA;EACA,oBAAA;AATN;AAWI;EACE,cAAA;EACA,qBAAA;EACA,oBAAA;AATN;;AAaA;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AAVF","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.toggle-button {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 50px;\n  border: 1px solid #ccc;\n  background: #fff;\n  position: relative;\n  height: 28px;\n\n  &.checked {\n    background: lighten($primary-color, 55);\n  }\n\n  &:hover {\n    border-color: $primary-color;\n  }\n  &__input {\n    display: none;\n\n    &:checked {\n      ~ .toggle-button__indicator {\n        background-color: $primary-color;\n        left: calc(100% - 28px);\n        border-color: lighten($primary-color, 55);\n      }\n\n      ~ .toggle-button__text {\n        &--checked {\n          display: block;\n        }\n        &--unchecked {\n          display: none;\n        }\n      }\n    }\n  }\n  &__indicator {\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    margin-right: 8px;\n    background: #ccc;\n    position: absolute;\n    transition: all 0.3s;\n  }\n  &__text {\n    &--checked {\n      display: none;\n      padding: 0 8px;\n      transition: all 0.3s;\n    }\n    &--unchecked {\n      display: block;\n      padding: 0 8px 0 30px;\n      transition: all 0.3s;\n    }\n  }\n}\n.checkbox-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n","$primary-color: #0abf53;\n\n// Screen size variables\n$screen-xxs-max: 370px; // Tiny phones\n$screen-xs-max: 425px; // Tiny phones\n$screen-sm-max: 576px; // Small tablets and large smartphones (landscape view)\n$screen-md-max: 767px; // Small tablets (portrait view)\n$screen-lg-max: 1024px; // Tablets and small desktops\n$screen-upper-lg-max: 1120px; // Tablets and small desktops\n$screen-xl-max: 1440px; // Large tablets and desktops\n\n// z-index\n$z-indexes: (\"login\", \"loginFooter\", \"loginOverlay\");\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
